<div
  data-testid="qa-guest-picker-root"
  id="qa_guestpicker"
  [ngClass]="
    'widget__item ' +
    (isFetching ? 'widget__item--loading' : '') +
    (classList | addClassList: { mainClass: 'widget__item--' }) +
    (adults > 0 ? ' widget__item--has-content' : '') +
    (!isUpdateable && !isFetching ? ' widget__item--readonly' : '') +
    ' widget__item--children-support' +
    (hideRooms ? '!p-0 !h-0 !border-0 !p-0' : '')
  "
>
  <div *ngIf="!hideRooms" class="widget__item-picker-wrap" (click)="!isExtension ? toggleDropdown() : null">
    <div
      [ngClass]="
        'widget__item-guest-plus-icon ' + (classList | addClassList: { mainClass: 'widget__item-guest-plus-icon--' })
      "
    >
      <ng-container *ngTemplateOutlet="limehomeCirclePlusSvg" />
    </div>
    <span
      [ngClass]="
        'widget__element-label ' +
        (classList | addClassList: { mainClass: 'widget__element-label--' }) +
        (adults ? ' widget__element-label--notEmpty' : '')
      "
      >{{ 'booking-widget-guests-rooms' | translate }}</span
    >
    <span
      id="qa_open-guests-overlay"
      [attr.class]="
        'widget__single-line widget__guest-line' + (classList | addClassList: { mainClass: 'widget__single-line--' })
      "
    >
      <span class="widget__guest-total-num" [ngClass]="{ 'widget__guest-total-num--lower-case': currentLang !== 'de' }">
        <span *ngIf="hideRooms" id="qa_guests-num">
          {{ adults | pluralize: 'adult' : 'adults' }}<ng-container *ngIf="children">{{ ',' }}</ng-container>
        </span>

        <ng-container *ngIf="children && hideRooms">
          {{ children | pluralize: 'child' : 'children' }}
        </ng-container>

        <span *ngIf="!hideRooms" id="qa_guests-num">
          {{ totalGuests | pluralize: 'guest' : 'guests' }}<ng-container *ngIf="rooms">{{ ',' }}</ng-container>
        </span>

        <span *ngIf="!hideRooms" id="qa_rooms-num">
          {{ rooms | pluralize: 'room' : 'rooms' }}
        </span>
      </span>

      <span
        *ngIf="!isExtension"
        [attr.class]="
          'widget__element-icon widget__guest-icon' +
          (classList | addClassList: { mainClass: 'widget__element-icon--' })
        "
      >
        <ng-container *ngTemplateOutlet="fontAwesomeLightUserPlusSvg" />
      </span>
    </span>
  </div>

  <!-- GUEST PICKER CONTROLS -->
  <div
    *ngIf="showDropdown && !this.isMobile"
    class="widget__dropdown"
    [ngClass]="{
      'widget__shadow-border md:w-[350px] left-0': useAsInventory
    }"
  >
    <ng-container *ngTemplateOutlet="incrementerItems" />
  </div>
</div>

<app-info-modal
  *ngIf="modalVars[guestPickerModalId]"
  class="lm-modal guest-modal guest-modal--children-support"
  [id]="guestPickerModalId"
  [modalOptions]="{
    disableMaxHeightChanges: true,
    disableMaxHeight: false,
    canGoFullScreenOnMobile: false,
    fullScreen: false,
    modalSize: 'modal-sm'
  }"
  (closeModal)="closeModal(guestPickerModalId, true)"
>
  <div class="guest-modal__content">
    <h5 class="h5--secondary guest-modal__header">
      {{ 'booking-widget-guests-rooms' | translate }}
    </h5>
    <ng-container *ngTemplateOutlet="incrementerItems" />

    <span *ngIf="maxGuests" class="text-xs font-semibold leading-xs">
      <i class="fa-regular fa-circle-info text-sm"></i>
      {{ 'pdp.cart.maxGuests' | translate: { maxGuests: maxGuests | pluralize: 'guest' : 'guests' } }}
    </span>
  </div>

  <!-- MODAL FOOTER -->
  <div
    class="sticky z-[5] border-none -bottom-4 mt-4 -mx-4 -mb-4 shadow-[0px_-4px_14px_0px_#0000001A] bg-primary p-4 flex flex-col"
  >
    <button
      class="widget__guest-picker-apply mb-3"
      data-testid="qa-guest-picker-search-button"
      (click)="confirmSelection()"
    >
      {{ ctaText ? (ctaText | translate) : ('home-main-search-btn' | translate) }}
    </button>

    @if (!useAsInventory) {
      <button class="button--clear-selection" (click)="clearSelection()">
        {{ 'guest-picker-clear' | translate }}
      </button>
    } @else {
      <button class="button--close-guest-picker" (click)="closeGuestPicker()">
        {{ 'booking-widget-cancel' | translate }}
      </button>
    }
  </div>
</app-info-modal>

<ng-template #incrementerControls let-value="value" let-type="type" let-maxValue="maxValue" let-minValue="minValue">
  <span
    data-testid="qa-guest-picker-decrement-default"
    id="qa_decrement-guests-mobile"
    [ngClass]="
      'widget__incrementer-control widget__incrementer-control-minus' +
      (classList !== '' ? ' widget__incrementer-control--' + classList : '') +
      (value === minValue ? ' widget__incrementer-control--grey' : '')
    "
    (click)="decrement(type)"
  >
    <span class="widget__incrementer-control-minus-default">
      <ng-container *ngTemplateOutlet="limehomeCircleMinusSvg" />
    </span>
    <span class="widget__incrementer-control-minus-hover">
      <ng-container *ngTemplateOutlet="fontAwesomeSolidCircleMinus" />
    </span>
  </span>
  <span class="font-semibold text-lg md:text-md" data-testid="qa-incrementer-value">{{ value }}</span>
  <span
    data-testid="qa-guest-picker-increment-default"
    id="qa_increment-guests-mobile"
    [ngClass]="
      'widget__incrementer-control widget__incrementer-control-plus ' +
      (classList !== '' ? ' widget__incrementer-control--' + classList : '') +
      (disabledIncrementerControl || value >= maxValue ? ' widget__incrementer-control--grey' : '')
    "
    (click)="!disabledIncrementerControl && increment(type)"
  >
    <span class="widget__incrementer-control-plus-default">
      <ng-container *ngTemplateOutlet="limehomeCirclePlusSvg" />
    </span>
    <span class="widget__incrementer-control-plus-hover" data-testid="qa_guest-picker-increment-hover">
      <ng-container *ngTemplateOutlet="fontAwesomeSolidCirclePlus" />
    </span>
  </span>
</ng-template>
<ng-template #incrementerItems>
  <div class="guest-picker-item-container pb-2">
    <div class="widget__guest-picker-item" data-testid="qa-guest-picker">
      <div class="widget__guest-picker-title">{{ 'adults' | translate }}</div>
      <div class="widget__incrementer">
        <ng-template
          [ngTemplateOutlet]="incrementerControls"
          [ngTemplateOutletContext]="{
            value: adultsTemp,
            type: valueType.adults,
            maxValue: bookingMaxAdults,
            minValue: 1
          }"
        ></ng-template>
      </div>
    </div>
    <div
      class="widget__guest-picker-item"
      [ngClass]="{
        'widget__guest-picker-item--no-border': !childrenAgesArrTemp.length && !isMobile && updateGuestWithoutRequest
      }"
    >
      <div class="widget__guest-picker-title">
        {{ 'children' | translate }}
        <span class="widget__guest-picker-title-info">{{ 'guest-picker-ages-range' | translate }}</span>
      </div>
      <div class="widget__incrementer">
        <ng-template
          [ngTemplateOutlet]="incrementerControls"
          [ngTemplateOutletContext]="{
            value: childrenTemp,
            type: valueType.children,
            maxValue: bookingMaxChildren,
            minValue: 0
          }"
        ></ng-template>
      </div>
    </div>

    <div class="widget__guest-picker-items-wrap">
      <div
        *ngFor="let child of childrenAgesArrTemp; let i = index"
        data-testid="qa_widget__guest-picker-items-wrap"
        class="widget__guest-picker-item widget__guest-picker-item--child"
      >
        <div class="widget__guest-picker-title">{{ 'child' | translate }} {{ i + 1 }}*</div>
        <div class="widget__age-select">
          <div
            data-testid="qa-widget__age-select"
            class="widget__age-select-value"
            [ngClass]="{ 'widget__age-select-value--error': isUnselectedAge && childrenAgesArrTemp[i] === null }"
            (click)="toggleAgeDropdown(i, $event)"
          >
            <span class="widget__age-select-value-wrap">{{
              childrenAgesArrTemp.length > 0 && childrenAgesArrTemp[i] !== null
                ? childrenAgesArrTemp[i]
                : isUnselectedAge && childrenAgesArrTemp[i] === null
                  ? ('guest-picker-age-needed' | translate)
                  : ('guest-picker-select-age' | translate)
            }}</span>
            <span
              class="widget__age-select-icon"
              data-testid="qa-widget__age-select-icon"
              [ngClass]="{ 'widget__age-select-icon--opened': showAgeDropdown && ageDropdownIndex === i }"
            >
              <ng-container *ngTemplateOutlet="fontAwesomeLightAngleDownSvg" />
            </span>
          </div>
          <div
            *ngIf="showAgeDropdown && ageDropdownIndex === i"
            class="widget__age-select-dropdown"
            data-testid="qa-widget__age-select-dropdown"
            appClickOutside
            (clickOutside)="toggleAgeDropdown(i, $event)"
            (click)="preventClick($event)"
          >
            <div #simpleScrollBar class="widget__simplebar" data-simplebar>
              <ul class="widget__age-select-list">
                <li
                  *ngFor="let age of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]"
                  class="widget__age-select-list-item"
                  [ngClass]="{
                    'widget__age-select-list-item--selected':
                      childrenAgesArrTemp.length > 0 && childrenAgesArrTemp[i] === age
                  }"
                  (click)="selectChildAge(i, age, $event)"
                >
                  {{ age }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="childrenAgesArrTemp.length"
      class="alert widget__guest-picker-alert mb-2"
      data-testid="qa-guest-picker-alert"
    >
      {{ 'guest-picker-alert-info' | translate }}
    </div>
    <div *ngIf="!hideRooms" class="widget__guest-picker-item capitalize" data-testid="qa-room-picker">
      <div class="widget__guest-picker-title">{{ 'rooms' | translate }}</div>
      <div class="widget__incrementer">
        <ng-template
          [ngTemplateOutlet]="incrementerControls"
          [ngTemplateOutletContext]="{
            value: roomsTemp,
            type: valueType.rooms,
            maxValue: bookingMaxRooms,
            minValue: 1
          }"
        ></ng-template>
      </div>
    </div>
  </div>

  <div *ngIf="!isMobile && !updateGuestWithoutRequest" class="flex flex-col widget__guest-picker-footer">
    <span *ngIf="maxGuests" class="text-xs font-semibold leading-xs mb-3 text-center">
      <i class="fa-regular fa-circle-info text-sm"></i>
      {{ 'pdp.cart.maxGuests' | translate: { maxGuests: maxGuests | pluralize: 'guest' : 'guests' } }}
    </span>

    <button
      class="widget__guest-picker-apply"
      sparkButton
      type="button"
      id="qa_search-button"
      data-testid="qa-guest-picker-search-button"
      (click)="confirmSelection()"
    >
      {{ ctaText ? (ctaText | translate) : ('home-main-search-btn' | translate) }}
    </button>
  </div>
</ng-template>
<ng-template #limehomeCircleMinusSvg>
  <svg
    width="24"
    height="24"
    viewBox="0 0 30 30"
    class="svg-inline--fa fa-circle-minus"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_30908_19739)">
      <path
        d="M15 4.125C10.8984 4.125 7.17969 6.3125 5.10156 9.8125C3.07812 13.3672 3.07812 17.6875 5.10156 21.1875C7.17969 24.7422 10.8984 26.875 15 26.875C19.0469 26.875 22.7656 24.7422 24.8438 21.1875C26.8672 17.6875 26.8672 13.3672 24.8438 9.8125C22.7656 6.3125 19.0469 4.125 15 4.125ZM15 29.5C9.96875 29.5 5.375 26.875 2.85938 22.5C0.34375 18.1797 0.34375 12.875 2.85938 8.5C5.375 4.17969 9.96875 1.5 15 1.5C19.9766 1.5 24.5703 4.17969 27.0859 8.5C29.6016 12.875 29.6016 18.1797 27.0859 22.5C24.5703 26.875 19.9766 29.5 15 29.5ZM11.0625 14.1875H18.9375C19.6484 14.1875 20.25 14.7891 20.25 15.5C20.25 16.2656 19.6484 16.8125 18.9375 16.8125H11.0625C10.2969 16.8125 9.75 16.2656 9.75 15.5C9.75 14.7891 10.2969 14.1875 11.0625 14.1875Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_30908_19739">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
</ng-template>
<ng-template #limehomeCirclePlusSvg>
  <svg
    width="24"
    height="24"
    viewBox="0 0 30 30"
    class="svg-inline--fa fa-circle-plus"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_30908_19730)">
      <path
        d="M15 4.125C10.8984 4.125 7.17969 6.3125 5.10156 9.8125C3.07812 13.3672 3.07812 17.6875 5.10156 21.1875C7.17969 24.7422 10.8984 26.875 15 26.875C19.0469 26.875 22.7656 24.7422 24.8438 21.1875C26.8672 17.6875 26.8672 13.3672 24.8438 9.8125C22.7656 6.3125 19.0469 4.125 15 4.125ZM15 29.5C9.96875 29.5 5.375 26.875 2.85938 22.5C0.34375 18.1797 0.34375 12.875 2.85938 8.5C5.375 4.17969 9.96875 1.5 15 1.5C19.9766 1.5 24.5703 4.17969 27.0859 8.5C29.6016 12.875 29.6016 18.1797 27.0859 22.5C24.5703 26.875 19.9766 29.5 15 29.5ZM13.6875 20.3125V16.8125H10.1875C9.42188 16.8125 8.875 16.2656 8.875 15.5C8.875 14.7891 9.42188 14.1875 10.1875 14.1875H13.6875V10.6875C13.6875 9.97656 14.2344 9.375 15 9.375C15.7109 9.375 16.3125 9.97656 16.3125 10.6875V14.1875H19.8125C20.5234 14.1875 21.125 14.7891 21.125 15.5C21.125 16.2656 20.5234 16.8125 19.8125 16.8125H16.3125V20.3125C16.3125 21.0781 15.7109 21.625 15 21.625C14.2344 21.625 13.6875 21.0781 13.6875 20.3125Z"
        fill="#0A0A0A"
      />
    </g>
    <defs>
      <clipPath id="clip0_30908_19730">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
</ng-template>
<ng-template #fontAwesomeSolidCirclePlus>
  <svg width="24" height="24" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_30908_19743)">
      <path
        d="M15 29.5C9.96875 29.5 5.375 26.875 2.85938 22.5C0.34375 18.1797 0.34375 12.875 2.85938 8.5C5.375 4.17969 9.96875 1.5 15 1.5C19.9766 1.5 24.5703 4.17969 27.0859 8.5C29.6016 12.875 29.6016 18.1797 27.0859 22.5C24.5703 26.875 19.9766 29.5 15 29.5ZM13.6875 20.3125C13.6875 21.0781 14.2344 21.625 15 21.625C15.7109 21.625 16.3125 21.0781 16.3125 20.3125V16.8125H19.8125C20.5234 16.8125 21.125 16.2656 21.125 15.5C21.125 14.7891 20.5234 14.1875 19.8125 14.1875H16.3125V10.6875C16.3125 9.97656 15.7109 9.375 15 9.375C14.2344 9.375 13.6875 9.97656 13.6875 10.6875V14.1875H10.1875C9.42188 14.1875 8.875 14.7891 8.875 15.5C8.875 16.2656 9.42188 16.8125 10.1875 16.8125H13.6875V20.3125Z"
        fill="#0A0A0A"
      />
    </g>
    <defs>
      <clipPath id="clip0_30908_19743">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
</ng-template>
<ng-template #fontAwesomeSolidCircleMinus>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6154_1419)">
      <path
        d="M12 24C7.6875 24 3.75 21.75 1.59375 18C-0.5625 14.2969 -0.5625 9.75 1.59375 6C3.75 2.29688 7.6875 0 12 0C16.2656 0 20.2031 2.29688 22.3594 6C24.5156 9.75 24.5156 14.2969 22.3594 18C20.2031 21.75 16.2656 24 12 24ZM8.625 10.875C7.96875 10.875 7.5 11.3906 7.5 12C7.5 12.6562 7.96875 13.125 8.625 13.125H15.375C15.9844 13.125 16.5 12.6562 16.5 12C16.5 11.3906 15.9844 10.875 15.375 10.875H8.625Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6154_1419">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</ng-template>
<ng-template #fontAwesomeLightUserPlusSvg>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_30908_19474)">
      <path
        d="M8.95801 4.9375C7.93848 4.9375 7.02441 5.5 6.49707 6.34375C6.00488 7.22266 6.00488 8.3125 6.49707 9.15625C7.02441 10.0352 7.93848 10.5625 8.95801 10.5625C9.94238 10.5625 10.8564 10.0352 11.3838 9.15625C11.876 8.3125 11.876 7.22266 11.3838 6.34375C10.8564 5.5 9.94238 4.9375 8.95801 4.9375ZM8.95801 12.25C7.34082 12.25 5.86426 11.4062 5.05566 10C4.24707 8.62891 4.24707 6.90625 5.05566 5.5C5.86426 4.12891 7.34082 3.25 8.95801 3.25C10.54 3.25 12.0166 4.12891 12.8252 5.5C13.6338 6.90625 13.6338 8.62891 12.8252 10C12.0166 11.4062 10.54 12.25 8.95801 12.25ZM7.34082 15.625C5.02051 15.625 3.12207 17.3477 2.80566 19.5625H15.0752C14.7588 17.3477 12.8604 15.625 10.54 15.625H7.34082ZM7.34082 13.9375H10.54C14.0205 13.9375 16.833 16.75 16.833 20.2305C16.833 20.793 16.3408 21.25 15.7783 21.25H2.10254C1.54004 21.25 1.08301 20.793 1.08301 20.2305C1.08301 16.75 3.86035 13.9375 7.34082 13.9375ZM18.8018 14.2188V11.9688H16.5518C16.0596 11.9688 15.708 11.6172 15.708 11.125C15.708 10.668 16.0596 10.2812 16.5518 10.2812H18.8018V8.03125C18.8018 7.57422 19.1533 7.1875 19.6455 7.1875C20.1025 7.1875 20.4893 7.57422 20.4893 8.03125V10.2812H22.7393C23.1963 10.2812 23.583 10.668 23.583 11.125C23.583 11.6172 23.1963 11.9688 22.7393 11.9688H20.4893V14.2188C20.4893 14.7109 20.1025 15.0625 19.6455 15.0625C19.1533 15.0625 18.8018 14.7109 18.8018 14.2188Z"
        fill="#0A0A0A"
      />
    </g>
    <defs>
      <clipPath id="clip0_30908_19474">
        <rect width="24" height="24" fill="white" transform="translate(0.333008)" />
      </clipPath>
    </defs>
  </svg>
</ng-template>
<ng-template #fontAwesomeLightAngleDownSvg>
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_30908_23791)">
      <path
        d="M11.1914 16.4336L5.56641 10.8086C5.10938 10.3867 5.10938 9.64844 5.56641 9.22656C5.98828 8.76953 6.72656 8.76953 7.14844 9.22656L12 14.043L16.8164 9.22656C17.2383 8.76953 17.9766 8.76953 18.3984 9.22656C18.8555 9.64844 18.8555 10.3867 18.3984 10.8086L12.7734 16.4336C12.3516 16.8906 11.6133 16.8906 11.1914 16.4336Z"
        fill="#0A0A0A"
      />
    </g>
    <defs>
      <clipPath id="clip0_30908_23791">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</ng-template>
